import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbMesureDatanameConstParam extends IAloDbBaseConstParam {
    MDN_ID:number|null
    MDN_KEY:string|null
  }

export class AloDbMesureDataname extends AloDbBase {
        
    public MDN_ID:number|null
    public MDN_KEY:string|null
    
    constructor({MDN_ID,MDN_KEY,...args }:IAloDbMesureDatanameConstParam = {} as IAloDbMesureDatanameConstParam) {
        super(args)
        this.MDN_ID = MDN_ID
        this.MDN_KEY = MDN_KEY
    }

    static createAloDbMesureDatanameArray(datas:any) {
        return new AloBaseArray(AloDbMesureDataname,datas)
    }

    static createAloDbMesureDatanameWithDetail(data:any) {
        return new AloDbMesureDataname({...data,detailLoaded:true})
    }
}
